// useNow — the current time, refreshed on an interval, so a status derived from a clock (a lease
// that ran out) changes on screen without a row change to trigger it. The time is the database
// server's (see server-clock.ts), because the leases it is compared to were written with that clock.

import { useEffect, useState } from 'react';
import { serverNow } from '@/lib/server-clock';

/** Redraw cadence of anything derived from the clock; the bridge renews its lease more often. */
export const NOW_TICK_MS = 5000;

export function useNow(tickMs: number = NOW_TICK_MS, active = true): number {
  const [now, setNow] = useState(() => serverNow());
  useEffect(() => {
    if (!active) return undefined;
    setNow(serverNow());
    const timer = setInterval(() => setNow(serverNow()), tickMs);
    return () => clearInterval(timer);
  }, [tickMs, active]);
  return now;
}
